<template>
  <div inline class="mgt-18" v-if="btns.length > 0">
    <el-button
      plain
      size="small"
      @click="exec(v.btnCode)"
      v-for="(v, i) in btns"
      :key="i"
      :type="v.btnCode == 'del' ? 'danger' : ''"
      >{{ v.btnName }}</el-button
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      btns: [],
    };
  },
  created() {
    // 初始加载按钮
    this.loadButtons();
  },
  watch: {
    $route: {
      deep: true,
      immediate: false,
      handler() {
        // 路由变化时重新加载按钮
        this.loadButtons();
      }
    },
    // 监听store中的菜单变化
    '$store.state.menu': {
      deep: true,
      handler() {
        this.loadButtons();
      }
    }
  },
  methods: {
    // 统一加载按钮的方法
    loadButtons() {
      let buttons = [];
      
      // 优先从路由meta获取
      console.log('this.$route.meta.btns', this.$route)
      if (this.$route.meta && Array.isArray(this.$route.meta.btns)) {
        console.log('this.$route.meta.btns', this.$route)
        buttons = this.$route.meta.btns;
        console.log('从路由meta获取按钮:', buttons);
      }
      
      // 如果路由meta没有按钮，尝试从store中查找
      console.log('vuex btns', this.$store.state.menu)
      if (buttons.length === 0 && this.$store.state.menu) {
        const menu = this.$store.state.menu;
        const currentRouteName = this.$route.name;
        
        // 递归查找当前路由对应的按钮
        const findButtonsInMenu = (menuItems) => {
          for (const item of menuItems) {
            if (item.name === currentRouteName && item.meta && item.meta.btns) {
              return item.meta.btns;
            }
            if (item.children && item.children.length > 0) {
              const found = findButtonsInMenu(item.children);
              if (found) return found;
            }
          }
          return null;
        };
        
        const foundButtons = findButtonsInMenu(menu);
        if (foundButtons) {
          buttons = foundButtons;
          console.log('从store菜单获取按钮:', buttons);
        }
      }
      
      // 如果还没有找到按钮，尝试从当前组件参数获取
      if (buttons.length === 0 && this.buttons) {
        buttons = this.buttons;
        console.log('从组件props获取按钮:', buttons);
      }
      
      // 初始化按钮
      this.initBtn(buttons);
    },
    
    initBtn(btns) {
      console.log("初始化按钮:", btns);
      if (btns && btns.length > 0) {
        const sortedBtns = [...btns].sort((a, b) => {
          const val1 = a.sort || 0;
          const val2 = b.sort || 0;
          return val1 - val2;
        });
        this.btns = sortedBtns;
      } else {
        this.btns = [];
      }
    },
    
    exec(fun) {
      this.$emit("exec", fun);
    }
  },
  // 也可以支持props传入按钮
  props: {
    buttons: {
      type: Array,
      default: () => []
    }
  }
};
</script>